import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
/**
 * Service zur Verhinderung von Logging in produktiven Umgebungen.
 * Begründung: @see TIME-979
 */
export class ConsoleLogService {
  disableLogsInProd(): void {
    // if production does not exist or production is true -> we're in prod
    if (environment?.production !== false) {
      globalThis.console.log = (): void => {
        /* empty */
      };

      globalThis.console.debug = (): void => {
        /* empty */
      };

      globalThis.console.info = (): void => {
        /* empty */
      };
    }
  }
}
